import React, { useContext } from 'react';
import { trackClick } from 'js/utils/trackClick';
import { WorkCardActionButton } from './WorkCard';
import { CiterightContext } from '../CiterightContextProvider';
import { WorkData } from '../types';
import { Icon } from 'js/design_system/Icon';

export const PaperEvaluationChatButton = ({ work }: { work: WorkData }) => {
  const context = useContext(CiterightContext);

  if (!context) {
    return null;
  }

  if (!work.work?.id || work.work.workType !== 'openalex_work') {
    return null;
  }

  const { setActiveWorkId } = context;
  return (
    <WorkCardActionButton
      secondary
      onClick={() => {
        trackClick({
          source: 'citeright.reference_chat_button',
          entityId: context?.reportId ?? undefined,
          extra: {
            suggestion_source: work.source,
          },
        });
        setActiveWorkId?.(work.work.id);
      }}
    >
      <Icon name="chat" size={16} />
      Ask about paper
    </WorkCardActionButton>
  );
};
